export default __webpack_public_path__ + "static/border_tablet-4f4000cabf47e12d985c58b1a6983938.png";